<div class="figurinha-tela" role="presentation" (click)="fechar()">
  <header class="figurinha-topo" role="presentation" (click)="$event.stopPropagation()">
    <div class="figurinha-autor">
      @if (data.fotoAutor && !fotoComErro()) {
        <img class="figurinha-avatar" [class.figurinha-avatar-foto]="data.fotoAutorReal" [src]="data.fotoAutor" alt="" (error)="fotoComErro.set(true)" />
      } @else {
        <app-avatar-pessoa [pessoa]="data.pessoaAutor" [tamanho]="40"></app-avatar-pessoa>
      }
      <div class="figurinha-info">
        <span class="figurinha-nome">{{ data.autor }}</span>
        @if (data.data) {
          <span class="figurinha-data">{{ rotuloData }} às {{ data.data | date: 'HH:mm' }}</span>
        }
      </div>
    </div>
    @if (data.podeResponder) {
      <button type="button" class="figurinha-btn" aria-label="Responder" matTooltip="Responder" (click)="responder()">
        <span class="chat-icone-duplo"><img src="./assets/icones/redesign/modulos/chat/components-message/reply.svg" alt="" class="chat-icone-base" /><img src="./assets/icones/redesign/modulos/chat/components-message/reply-primary.svg" alt="" class="chat-icone-ativo" /></span>
      </button>
    }
    <button type="button" class="figurinha-btn" aria-label="Fechar" matTooltip="Fechar" (click)="fechar()">
      <img src="./assets/icones/redesign/utils/close.svg" alt="" />
    </button>
  </header>

  <div class="figurinha-palco">
    @if (comErro()) {
      <div class="figurinha-erro" role="presentation" (click)="$event.stopPropagation()">
        <mat-icon>hide_image</mat-icon>
        <span>Figurinha indisponível</span>
      </div>
    } @else {
      <img class="figurinha-imagem" @pop [src]="data.url" alt="Figurinha" draggable="false"
           (click)="$event.stopPropagation()" (error)="comErro.set(true)" />
    }
  </div>
</div>
